import React from "react";
import PlaceholderContainer from "./PlaceholderContainer";
import { Placeholder, PlaceholderLine } from 'placeholders/Placeholder'

const PlaceholderMessage = ({ containerStyle = {} }) => {

	return (
		<PlaceholderContainer style={ containerStyle }>
			<Placeholder>
				<PlaceholderLine width={50} />
				<PlaceholderLine />
				<PlaceholderLine />
			</Placeholder>
		</PlaceholderContainer>
	)
}

export default PlaceholderMessage
